import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EmployeeFreebieModel } from './employee-freebie.model';

export class EmployeeFreebiesResponse extends GlobalResponseObject {
    data?: EmployeeFreebieModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: EmployeeFreebieModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
